<zef-form
  [state]="state"
  (submit)="submit.emit()">

  <zui-form-section separator="none">

    <span *zuiFormSectionTitle>
      Auto Top-up Configuration
    </span>

    <div *zuiFormSectionDesc>
      When your balance (credit + promo credit) drops below the threshold,
      Zerops automatically charges your saved card by the top-up amount.
      The calendar-month limit (UTC) is a hard cap on how much can be auto-charged within a single calendar month.
    </div>

    <div class="fx:pt-0-5">

      <zef-form-field
        last
        class="__radio-form-field"
        [appearance]="'radio'">

        <zef-form-label>Auto top-up:</zef-form-label>

        <mat-radio-group
          class="__radio-group"
          [ngrxEnableFocusTracking]="true"
          [ngrxFormControlState]="state?.controls.enabled">

          <mat-radio-button class="__radio" [value]="false">
            Disable
          </mat-radio-button>

          <mat-radio-button class="__radio" [value]="true">
            Enable
          </mat-radio-button>

        </mat-radio-group>

      </zef-form-field>

      @if (state.value.enabled) {

        <zui-separator
          class="fx:pl-0-5"
          [size]="'mini'"
          [position]="'start'"
          [spacing]="'mini'"
        />

        <zef-form-field>
          <mat-form-field color="accent">
            <mat-label>When credits drop below:</mat-label>
            <input
              matInput
              type="number"
              placeholder="50"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.threshold"
            />
            @if (state?.controls.threshold.errors?.required) {
              <mat-error>Required.</mat-error>
            } @else if (state?.controls.threshold.errors?.greaterThanOrEqualTo) {
              <mat-error>Must be at least 5.</mat-error>
            }
          </mat-form-field>
        </zef-form-field>

        <zef-form-field>
          <mat-form-field color="accent">
            <mat-label>Top up by:</mat-label>
            <input
              matInput
              type="number"
              placeholder="100"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.amount"
            />
            @if (state?.controls.amount.errors?.required) {
              <mat-error>Required.</mat-error>
            } @else if (state?.controls.amount.errors?.greaterThanOrEqualTo) {
              <mat-error>Must be at least 10.</mat-error>
            }
          </mat-form-field>
        </zef-form-field>

        <zef-form-field last>
          <mat-form-field color="accent">
            <mat-label>With monthly (calendar) limit of:</mat-label>
            <input
              matInput
              type="number"
              placeholder="300"
              [ngrxEnableFocusTracking]="true"
              [ngrxFormControlState]="state?.controls.calendarMonthlyLimit"
            />
            @if (state?.controls.calendarMonthlyLimit.errors?.required) {
              <mat-error>Required.</mat-error>
            } @else if (state?.controls.calendarMonthlyLimit.errors?.greaterThanOrEqualTo) {
              <mat-error>Must be at least the top-up amount.</mat-error>
            }
          </mat-form-field>
        </zef-form-field>
      }

    </div>

  </zui-form-section>
</zef-form>
